import React from "react";

function PreLoader() {
  return (
    <div className="flex items-center justify-center h-screen bg-white z-50">
      <img
        src="initialLoading.gif"
        alt="initial loading"
        className="w-full h-full object-contain"
      />
    </div>
  );
}

export default PreLoader;
